<template>
  <div
    :class="[
      'flex flex-column relative input-content',
      !noSpace ? 'gap-2' : null,
    ]"
  >
    <div class="flex gap-1">
      <label
        v-if="props.label"
        :for="props.id"
        :class="[
          'tv__input-label',
          props.size === 'sm' ? 'tv__input-sm-label' : '',
        ]"
      >
        {{ props.label }}
      </label>
      <TVTooltip
        v-if="props.tooltipMessage"
        :maxWidthTooltip="300"
        floatTooltipDesk="top"
        floatTooltipMobile="bottom"
        :useMaterialIcon="true"
        iconName="info"
        triggerEvent="click"
      >
        <template #title>
          <p v-html="props.tooltipMessage"></p>
        </template>
      </TVTooltip>
    </div>
    <Dropdown
      v-model="selectedItemValue"
      :options="props.options || []"
      :class="inputClasses"
      :option-label="props.optionLabel || 'text'"
      option-value="value"
      :placeholder="props.placeholder || ''"
      :disabled="props.disabled"
      :auto-filter-focus="!isMobile"
      :editable="props.editable"
      :invalid="props.error || props.customErrorMessage"
      :aria-describedby="props.id ? props.id + '-help' : ''"
      :filter="!props.editable && props.options && props.options.length > 5"
      :checkmark="props.checkmark"
      :loading="props.loading"
      :pt="{
        filterIcon: () => ({
          style: {
            right: 'unset',
            left: '24px',
          },
        }),
        filterInput: () => ({
          style: {
            padding: '1rem 1rem 1rem 2.25rem',
          },
        }),
      }"
      @change="handleChange"
      translate="no"
      class="notranslate"
    />
    <span
      v-if="!props.noHelMessage"
      :class="[!noSpace ? 'input-message-content' : null]"
    >
      <p v-if="props.helpMessage && !hasError" class="tv__input-help">
        {{ props.helpMessage }}
      </p>
      <div v-if="hasError" class="tv__input-error-message flex">
        <i class="tv__input-icon tv__input-icon-error"></i>
        {{ props.customErrorMessage }}
      </div>
    </span>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, defineEmits, watch } from "vue";
import Dropdown from "primevue/dropdown";
import TVTooltip from "./Tooltip.vue";

const props = defineProps({
  name: String,
  value: String,
  label: String,
  placeholder: String,
  id: String,
  disabled: Boolean,
  noSpace: Boolean,
  noHelMessage: Boolean,
  error: Boolean,
  customErrorMessage: String,
  helpMessage: String,
  editable: Boolean,
  tooltipMessage: String,
  tooltipDirDesk: String,
  tooltipDirMobile: String,
  tooltipMaxWidth: Number,
  acceptEmpty: Boolean,
  modelValue: String,
  checkmark: {
    type: Boolean,
    default: true,
  },
  optionLabel: {
    type: String,
    default: "text",
  },
  size: {
    type: String,
    default: "lg",
    validator: (value) => ["lg", "sm"].includes(value),
  },
  options: {
    type: Array,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits([
  "update:modelValue",
  "change-value",
  "update:allInfo",
]);

const isMobile = computed(() => {
  if (typeof window !== "undefined") {
    return window.innerWidth <= 768;
  }
  return false;
});

const selectedItemValue = ref(props.modelValue || props.value || null);

const inputClasses = computed(() => [
  "tv__input",
  props.size === "sm" ? "tv__input-sm" : null,
  props.editable ? "tv__input-editable" : null,
]);

const hasError = computed(() => props.error || !!props.customErrorMessage);

const handleChange = (event) => {
  const selectedFullOption = event.value;
  const selectedObject = props.options?.find(
    (opt) => opt.value === selectedFullOption
  );

  emits("change-value", selectedFullOption);
  emits("update:modelValue", selectedFullOption);
  emits("update:allInfo", selectedObject);
};

watch(
  () => props.modelValue,
  (newValue) => {
    selectedItemValue.value = newValue;
  },
  { immediate: true }
);
</script>
